// import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    FormControl,
//    FormErrorMessage,
//    Input,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    // Box,
//    // Stepper,
//    // Step,
//    // StepIndicator,
//    // StepStatus,
//    // StepIcon,
//    // StepNumber,
//    // StepTitle,
//    // StepDescription,
//    // StepSeparator,
//    useToast,
//    FormLabel,
//    Select,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { addItemGroup, updateItemGroup } from '../../../../../redux/actions/itemGroup';
// import { renderFormControl } from 'utils/DynamicFormData';
// // import { renderSelectFormControl } from 'utils/DynamicFormData';
// import { getHsn } from '../../../../../redux/actions/hsn';
// import { getItem } from '../../../../../redux/actions/item';
// import '../../../companyProfile/css.css';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { useUser } from 'contexts';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from '../../../../../components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useGlobal } from '../../../../../contexts';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required'),
//    // parentId: Yup.number()
//    //   .required('parentId is required')
//    //   .typeError('parentId must be a number'), // Ensures it's a number

//    // hsnId: Yup.number()
//    //   .required('hsnId is required')
//    //   .typeError('hsnId must be a number'), // Ensures it's a number

//    // sacId: Yup.number()
//    //   .required('sacId is required')
//    //   .typeError('sacId must be a number'), // Ensures it's a number
// });

// const steps = [
//    { title: 'First', description: 'Enter Item Information' },
//    { title: 'Second', description: 'Review and Save' },
// ];

// const ItemGroupMasterForm = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    demoname,
//    currentRow = null,
//    onSave,
//    saveandcontinue = true,
//    isAbs = false,
// }) => {
//    const [row, setRow] = useState({
//       name: '',
//       parentId: '',
//       hsnId: '',
//       sacId: '',
//       compIds: [],
//    });
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;
//    const shouldSendCompanyidItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
//    const [errors, setErrors] = useState({});
//    // const [activeStep, setActiveStep] = useState(0);
//    const toast = useToast();
//    const { user } = useUser();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const [isLoading, setIsLoading] = useState(false);
//    const hsnData = useSelector((state) => state.hsn.list);
//    const itemData = useSelector((state) => state.item.list);

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          parentId: '',
//          hsnId: '',
//          sacId: '',
//          compIds: [],
//       });
//       setErrors({});
//    };

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData(); // Clear data when adding a new item
//       } else if (isEditMode && currentRow) {
//          setRow({
//             name: currentRow.name || '',
//             parentId: currentRow.parentId || '',
//             hsnId: currentRow.hsnId || '',
//             sacId: currentRow.sacId || '',
//             compIds: currentRow.compIds || [],
//          });
//       }
//    }, [isEditMode, currentRow]);

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(getHsn());
//          dispatch(
//             getItem({
//                companyId: user.loginhistory.companyId,
//                ...(shouldSendCompanyidItem && { companyIds: user?.loginhistory?.companyId }),
//             }),
//          );
//       }
//    }, [dispatch, isOpen]);

//    const validateStep = async () => {
//       try {
//          // Validate the whole row object instead of individual fields
//          await validationSchema.validate(row, { abortEarly: false });

//          setErrors({}); // Clear previous errors
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));

//       // Clear the specific field error when user starts typing
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    // const handleNext = async () => {
//    //   const isValid = await validateStep();
//    //   if (isValid) {
//    //     if (activeStep < steps.length - 1) {
//    //       setActiveStep(activeStep + 1);
//    //     }
//    //   } else {
//    //     toast({
//    //       title: "Validation Error",
//    //       description: "Please correct the errors before proceeding.",
//    //       status: "error",
//    //       duration: 3000,
//    //       isClosable: true,
//    //     });
//    //   }
//    // };

//    // const handlePrevious = () => {
//    //   if (activeStep > 0) {
//    //     setActiveStep(activeStep - 1);
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          parentId: Number(row.parentId),
//          hsnId: Number(row.hsnId),
//          sacId: Number(row.sacId),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateItemGroup(processedData));
//          } else {
//             // Add new item
//             await dispatch(addItemGroup(processedData));
//          }
//          setIsLoading(false);
//          // Close the modal
//          onClose();
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the category.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          parentId: Number(row.parentId),
//          hsnId: Number(row.hsnId),
//          sacId: Number(row.sacId),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateItemGroup(processedData));
//          } else {
//             // Add new item
//             await dispatch(addItemGroup(processedData));
//          }
//          setIsLoading(false);
//          clearFormData();
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the category.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit(); // Call the form submit logic if validation is successful
//       } else {
//          if (!row.name || row.name.trim() === '') {
//             setTimeout(() => {
//                nameInputRef.current?.focus(); // Focus the name input
//             }, 100);
//             return;
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue(); // Call the form submit logic if validation is successful
//       } else {
//          if (!row.name || row.name.trim() === '') {
//             setTimeout(() => {
//                nameInputRef.current?.focus(); // Focus the name input
//             }, 100);
//             return;
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (e.key.toLowerCase() === 's') {
//             e.preventDefault();

//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S --- save & continue
//             } else {
//                handleSubmit(); // S --- Save & Finish
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             handleCansel(); // c --- cansel
//          }
//          // if (e.key.toLowerCase() === 'p') {
//          //    handlePrevious(); // p --- Previous
//          // }
//          // if (e.key.toLowerCase() === 'n') {
//          //    handleNext(); // n --- next
//          // }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    const hsnOptions = hsnData.map((item) => ({
//       label: item.hsn,
//       value: item.id,
//       name: item.hsn,
//       id: item.id,
//       gsttypename: item.gsttypename,
//    }));

//    const nameInputRef = useRef();
//    const parentRef = useRef();
//    const hsnRef = useRef();
//    const sacRef = useRef();
//    const saveFinishRef = useRef();

//    const handleCansel = async () => {
//       onClose();
//       if (!isEditMode) {
//          clearFormData();
//       }
//    };

//    useEffect(() => {
//       if (demoname && row.name === '') {
//          setRow((prev) => ({ ...prev, name: demoname }));
//       }
//       demoname = '';
//    }, [demoname, row.name]);

//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);

//    const dbName = localStorage.getItem('dbName');

//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             handleCansel();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [handleCansel]);

//    return (
//       <Modal isOpen={isOpen} onClose={handleCansel} size="3xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '45%', md: '25%', xl: '15%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600">
//                {isEditMode ? 'Edit Item Group' : 'Add New Item Group'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                {/* <Stepper index={activeStep} colorScheme="teal">
//             {steps.map((step, index) => (
//               <Step key={index}>
//                 <StepIndicator>
//                   <StepStatus
//                     complete={<StepIcon />}
//                     incomplete={<StepNumber />}
//                     active={<StepNumber />}
//                   />
//                 </StepIndicator>
//                 <Box flexShrink="0">
//                   <StepTitle>{step.title}</StepTitle>
//                   <StepDescription>{step.description}</StepDescription>
//                 </Box>
//                 <StepSeparator />
//               </Step>
//             ))}
//           </Stepper> */}

//                {/* {activeStep === 0 && ( */}
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }} gap={2}>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            disabled: isEditMode && isAbs,
//                            ref: nameInputRef, // ✅ Pass the ref here
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  parentRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'parentId',
//                         'Parent Item',
//                         itemData,
//                         {
//                            value: row.parentId,
//                            onChange: (value) => handleInputChange('parentId', value),
//                            ref: parentRef, // ✅ Pass the ref here
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  hsnRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false, // isRequired
//                         'Select Parent Item', // placeholder
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'hsnId',
//                         'HSN',
//                         hsnOptions.filter((hsn) => hsn.gsttypename === 'Goods'),
//                         {
//                            value: row.hsnId,
//                            onChange: (value) => handleInputChange('hsnId', value),
//                            showCustomNoOptions: true,
//                            openfrom: 'hsn',
//                            ref: hsnRef, // ✅ Pass the ref here
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  sacRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false, // isRequired
//                         'Select HSN', // placeholder
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'sacId',
//                         'SAC ID',
//                         hsnOptions.filter((hsn) => hsn.gsttypename === 'Services'),
//                         {
//                            value: row.sacId,
//                            onChange: (value) => handleInputChange('sacId', value),
//                            ref: sacRef, // ✅ Pass the ref here
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  saveFinishRef.current?.focus();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false, // isRequired
//                         'Select SAC', // placeholder
//                      )}
//                   </GridItem>
//                   {shouldSendCompanyidItemGroup && (
//                      <GridItem className="seperator-width">
//                         {renderDynamicUiDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: row.compIds,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                </Grid>
//                {/* )} */}
//             </ModalBody>
//             <ModalFooter>
//                {/* {activeStep > 0 && (
//             <Button
//               onClick={handlePrevious}
//               variant="ghost"
//               colorScheme="teal"
//               mr={3}
//             >
//               Previous
//             </Button>
//           )}

//           {activeStep < steps.length - 1 && (
//             <Button
//               onClick={handleNext}
//               colorScheme="teal"
//             >
//               Next
//             </Button>
//           )} */}
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   ref={saveFinishRef}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>

//                <Button variant="ghost" onClick={handleCansel} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default ItemGroupMasterForm;

import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   useColorMode,
   useColorModeValue,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { addItemGroup, updateItemGroup } from '../../../../../redux/actions/itemGroup';
import { getHsn } from '../../../../../redux/actions/hsn';
import { getItem } from '../../../../../redux/actions/item';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { useUser } from 'contexts';
import { renderDynamicDropdown as renderDynamicUiDropdown } from '../../../../../components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal } from '../../../../../contexts';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required'),
});

const ItemGroupMasterForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   onSave,
   saveandcontinue = true,
   isAbs = false,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [row, setRow] = useState({
      name: '',
      parentId: '',
      hsnId: '',
      sacId: '',
      compIds: [],
   });
   const { companyList, userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;
   const shouldSendCompanyidItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const [errors, setErrors] = useState({});
   const toast = useToast();
   const { user } = useUser();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const dispatch = useDispatch();
   const [isLoading, setIsLoading] = useState(false);
   const hsnData = useSelector((state) => state.hsn.list);
   const itemData = useSelector((state) => state.item.list);

   // Function to clear form data
   const clearFormData = () => {
      setRow({
         name: '',
         parentId: '',
         hsnId: '',
         sacId: '',
         compIds: [],
      });
      setErrors({});
   };

   // Populate form with current row data when in edit mode
   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
      } else if (isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            parentId: currentRow.parentId || '',
            hsnId: currentRow.hsnId || '',
            sacId: currentRow.sacId || '',
            compIds: currentRow.compIds || [],
         });
      }
   }, [isEditMode, currentRow]);

   const [hasFetched, setHasFetched] = useState(false);

   useEffect(() => {
      if (isOpen && !hasFetched) {
         dispatch(getHsn());
         dispatch(
            getItem({
               companyId: user.loginhistory.companyId,
               ...(shouldSendCompanyidItem && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         setHasFetched(true);
      }

      // Reset when modal closes
      if (!isOpen && hasFetched) {
         setHasFetched(false);
      }
   }, [dispatch, isOpen, hasFetched, user.loginhistory.companyId, shouldSendCompanyidItem]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         parentId: Number(row.parentId),
         hsnId: Number(row.hsnId),
         sacId: Number(row.sacId),
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateItemGroup(processedData));
         } else {
            await dispatch(addItemGroup(processedData));
         }
         setIsLoading(false);
         onClose();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         parentId: Number(row.parentId),
         hsnId: Number(row.hsnId),
         sacId: Number(row.sacId),
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateItemGroup(processedData));
         } else {
            await dispatch(addItemGroup(processedData));
         }
         setIsLoading(false);
         clearFormData();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         if (!row.name || row.name.trim() === '') {
            setTimeout(() => {
               nameInputRef.current?.focus();
            }, 100);
            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         if (!row.name || row.name.trim() === '') {
            setTimeout(() => {
               nameInputRef.current?.focus();
            }, 100);
            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            e.preventDefault();

            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            handleCansel();
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   const hsnOptions = hsnData.map((item) => ({
      label: item.hsn,
      value: item.id,
      name: item.hsn,
      id: item.id,
      gsttypename: item.gsttypename,
   }));

   const nameInputRef = useRef();
   const parentRef = useRef();
   const hsnRef = useRef();
   const sacRef = useRef();
   const saveFinishRef = useRef();
   const cancelRef = useRef();
   const savecontinueRef = useRef();
   const handleCansel = async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
   };

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100);
   }, [isOpen]);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const dbName = localStorage.getItem('dbName');

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleCansel();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleCansel]);

   return (
      <Modal isOpen={isOpen} onClose={handleCansel} size="3xl">
         <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
         <ModalContent bg="transparent" boxShadow="none" mx="15px" mt={{ base: '45%', md: '25%', xl: '15%' }}>
            <div
               className={`rounded-2xl shadow-xl overflow-hidden
               ${isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}
            `}>
               {/* Colored top border */}
               <div className="h-1 bg-gradient-to-r from-purple-500 via-blue-500 to-indigo-500" />

               {/* Header */}
               <ModalHeader className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                  <div className="flex items-center gap-3">
                     <div className="w-1 h-8 bg-gradient-to-b from-purple-500 to-blue-500 rounded-full" />
                     <div>
                        <h2 className={`text-xl font-semibold ${isDark ? 'text-purple-400' : 'text-purple-600'}`}>
                           {isEditMode ? 'Edit Item Group' : 'Add New Item Group'}
                        </h2>
                        <p className={`text-xs mt-0.5 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                           {isEditMode ? 'Update item group details' : 'Create a new item group for your organization'}
                        </p>
                     </div>
                  </div>
               </ModalHeader>

               <ModalCloseButton
                  className={`top-5 right-5 rounded-md ${
                     isDark
                        ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                  }`}
                  _focus={{
                     boxShadow: '0 0 0 2px rgba(99, 102, 241, 0.5)',
                     outline: 'none',
                  }}
               />

               {/* Body */}
               <ModalBody className="px-6 py-5">
                  <Grid
                     templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                     gap={4}>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'name',
                           'Name',
                           {
                              value: row.name,
                              onChange: (e) => handleInputChange('name', e.target.value),
                              disabled: isEditMode && isAbs,
                              ref: nameInputRef,
                              placeholder: 'Enter item group name',
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    parentRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'text',
                           true,
                        )}
                     </GridItem>

                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'parentId',
                           'Parent Item',
                           itemData,
                           {
                              value: row.parentId,
                              onChange: (value) => handleInputChange('parentId', value),
                              ref: parentRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    hsnRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           false,
                           'Select Parent Item',
                        )}
                     </GridItem>

                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'hsnId',
                           'HSN',
                           hsnOptions.filter((hsn) => hsn.gsttypename === 'Goods'),
                           {
                              value: row.hsnId,
                              onChange: (value) => handleInputChange('hsnId', value),
                              showCustomNoOptions: true,
                              openfrom: 'hsn',
                              ref: hsnRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    sacRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           false,
                           'Select HSN',
                        )}
                     </GridItem>

                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'sacId',
                           'SAC ID',
                           hsnOptions.filter((hsn) => hsn.gsttypename === 'Services'),
                           {
                              value: row.sacId,
                              onChange: (value) => handleInputChange('sacId', value),
                              ref: sacRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    saveFinishRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           false,
                           'Select SAC',
                        )}
                     </GridItem>

                     {shouldSendCompanyidItemGroup && (
                        <GridItem className="seperator-width">
                           {renderDynamicUiDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: row.compIds,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     )}
                  </Grid>
               </ModalBody>

               {/* Footer */}
               <ModalFooter
                  className={`px-6 py-4 border-t flex flex-wrap gap-3 justify-end ${
                     isDark
                        ? 'border-gray-700/50 bg-gradient-to-r from-gray-800/50 to-gray-900/50'
                        : 'border-gray-200 bg-gradient-to-r from-gray-50 to-white'
                  }`}>
                  {!isEditMode && saveandcontinue === true && (
                     <Button
                        ref={savecontinueRef}
                        onClick={handlesavecontinue}
                        isLoading={isLoading}
                        disabled={isLoading}
                        size="sm"
                        className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5
        ${
           isDark
              ? 'bg-gradient-to-r from-emerald-600 to-emerald-500 text-white hover:from-emerald-500 hover:to-emerald-400 border border-emerald-400/50'
              : 'bg-gradient-to-r from-emerald-500 to-emerald-600 text-white hover:from-emerald-600 hover:to-emerald-700 border-2 border-emerald-400/30'
        }
      `}
                        _focus={{
                           boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.4)',
                           outline: 'none',
                        }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              saveFinishRef.current?.focus();
                           }
                        }}>
                        <span className="flex items-center gap-2">
                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                           </svg>
                           Save & Continue
                        </span>
                     </Button>
                  )}

                  <Button
                     onClick={handleSubmit}
                     isLoading={isLoading}
                     disabled={isLoading}
                     ref={saveFinishRef}
                     size="sm"
                     className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5
      ${
         isDark
            ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-500 hover:to-blue-400 border border-blue-400/50'
            : 'bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 border-2 border-blue-400/30'
      }
    `}
                     _focus={{
                        boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)',
                        outline: 'none',
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode) {
                              savecontinueRef.current?.focus();
                           }
                        }
                     }}>
                     <span className="flex items-center gap-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                           />
                        </svg>
                        Save & Finish
                     </span>
                  </Button>

                  <Button
                     ref={cancelRef}
                     onClick={handleCansel}
                     size="sm"
                     className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5
      ${
         isDark
            ? 'bg-gradient-to-r from-red-600/80 to-red-500/80 text-white hover:from-red-500 hover:to-red-400 border border-red-400/50'
            : 'bg-white text-red-600 hover:bg-red-50 border-2 border-red-300 hover:border-red-400'
      }
    `}
                     _focus={{
                        boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.3)',
                        outline: 'none',
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           saveFinishRef.current?.focus();
                        }
                     }}>
                     <span className="flex items-center gap-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                           />
                        </svg>
                        Cancel
                     </span>
                  </Button>
               </ModalFooter>
            </div>
         </ModalContent>
      </Modal>
   );
};

export default ItemGroupMasterForm;
